import React, { useState } from 'react';
import { accountService } from '../components/services/account/AccountService';
import './Logout.css';



const Logout = () => {

    const handleSubmit = (event) => {
        event.preventDefault();
        accountService.logout();
        // Redirection vers la page de tableau de bord
        window.location.href = '/';
    };


    return (
        <>
            <div className='login-section'>
                <div className="form-box">
                    <div className="form-value">
                        <form onSubmit={handleSubmit}>
                            <h2>Log Out</h2>
                            <br />
                            <div>Are you sure you want to log out?</div>
                            <br />
                            <button type="submit">Confirm</button>
                            <div className="register">
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Logout;
